import { sessionId } from './sessionKey';

/**
 * Signing out ends whatever you were holding open.
 *
 * A معلم who signed out left their session `status: 'open'` and advertising
 * itself. Presence hides it from discovery within a minute, and the day-end
 * sweep closes it eventually — but signing out is an explicit, deliberate
 * "I am done", and leaving a session running behind it is the app ignoring
 * what the person just said.
 *
 * Closing FIRST, then signing out: closeSession is a callable and needs the
 * credential that signing out destroys. Reversing the two makes the close
 * fail every time, silently.
 *
 * A failure to close is never allowed to trap someone in the app. Signing out
 * is the thing they asked for; the sweep is the backstop for the rest.
 */
export async function signOutAndCloseSession(deps: {
  muqriId: string | null;
  isMuqri: boolean;
  closeSession: (id: string) => Promise<void>;
  signOut: () => Promise<void>;
  now?: () => Date;
}): Promise<void> {
  const { muqriId, isMuqri, closeSession, signOut, now = () => new Date() } = deps;

  if (isMuqri && muqriId) {
    try {
      await closeSession(sessionId(muqriId, now()));
    } catch {
      // Already closed, never opened, or the network is gone. None of those
      // are a reason to keep somebody signed in.
    }
  }

  await signOut();
}
